export default "__VITE_ASSET__BZJTB3dI__"